import { useLocation } from 'react-router-dom';

const useIsBackOffice = () => {
  const location = useLocation();
  return location.pathname.includes('admin');
};

export default useIsBackOffice;
